// extracted by mini-css-extract-plugin
export default {"progress":"ProgressBar_progress__fBVV6","progress__bar":"ProgressBar_progress__bar__Zmt-T","progress__percentage":"ProgressBar_progress__percentage__63PWQ"};